<template>
	<div class="h-header" style="z-index:1002">

      <div id="buttonContainer">
          <button id="backToTopBtn">
              <img src="../../public/assets/images/flow/it_fuwu.png" @click="getItfuwu" alt="Back to Top" style="width: 50px; height: 50px;" >
          </button>
          <div id="toggleBtn" @click="changeBtn()">
              <img src="../../public/assets/images/flow/it_down.png" id="suofang" alt="Toggle Button" style="width: 20px; height: 20px;">
          </div>
      </div>
		<div class="h-headL">
			<a class="h-logo1"><img src="../assets/images/h-logo1-icon.png"></a>
		</div>
		<div class="h-headR">
			<a class="h-logo2"><img src="../assets/images/h-logo2-icon.png"></a>
			<div class="msg">
				有问题请通过OMS系统右下角IT服务台咨询<br>运维人员优先处理IT服务台问题！
			</div>
			<div class="h-fr h-disTable">
				<div class="h-tableCell">
					<!--暂时隐藏-->
					<div class="h-headLink" >
						<el-tooltip content="消息中心" effect="light">
							<a @click="toMsgCenter" title="消息中心">
								<img src="../assets/images/h-header-icon1.png">
								<span v-if="this.$store.getters.checkedTotal !== 0" class="h-linkNum">{{this.$store.getters.checkedTotal}}</span>
							</a>
						</el-tooltip>
					</div>
					<div class="h-headLink" >
						<el-tooltip content="待办中心" effect="light">
							<a @click="toTaskCenter" title="待办中心">
								<img src="../assets/images/h-header-icon2.png">
								<span v-if="this.$store.getters.tasktotal !== 0"class="h-linkNum">{{this.$store.getters.tasktotal}}</span>
							</a>
						</el-tooltip>
					</div>
					<div class="h-headLink" style="color:#fff">
						<a @click="toUserCenter">
							{{this.$store.getters.user.username}}[{{this.$store.getters.user.usercode}}]
						</a>
					</div>
					<div class="h-headLink" style="color:#fff">
						<a @click="tuichu">
							退出系统
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
    import {
        Loading,
        Message,
        MessageBox
    } from 'element-ui';
    import ss from "../api/SystemService";
export default {
	name:'Commonheader',
	methods:{
        toMsgCenter(){
            this.$router.push({path:"/personal/messageCenter"})
        },
        toTaskCenter(){
            this.$router.push({path:"/personal/dealCenter"})
        },
        toUserCenter(){
            this.$router.push({path:"/personal/userin"})
		},
        tuichu(){
          this.$msg.confirm("确认退出？",()=> {
            if(this.$store.getters.user.usertype == 1 || this.$store.getters.user.usertype == 2){
              this.$store.commit("LOGOUT")
            }else {
              ss.LoginService.getLogOutUrl().then(rd => {
                window.location.href = rd
              })
              this.$store.commit("LOGOUT")
            }
          })
		},
		getItfuwu(){
			var userid = this._user.usercode
			ss.LoginService.getItPt(userid).then(rd => {
				window.open( rd, '_blank')
			})
		},
		changeBtn(){
			var btn = document.getElementById("backToTopBtn");
			if (btn.style.display === "none") {
				btn.style.display = "block";
			} else {
				btn.style.display = "none";
			}
			var suofang = document.getElementById("suofang");
			if (btn.style.display === "none") {
				suofang.src = require("../../public/assets/images/flow/it_up.png");
			} else {
				suofang.src = require("../../public/assets/images/flow/it_down.png");
			}
		}
	},
	created(){
	//    加载消息
        this.$store.dispatch('searchMsgPage');
        this.$store.dispatch('searchTasktotal');
		this.$store.dispatch('searchCheckedTotal');
		// var aa = localStorage.getItem("_alert_msg_");
		// if(!aa){
        //     this.$notify({
        //         title: '系统提醒',
        //         message: '系统在7月2日零时停机维护，持续时间1个小时，对于系统维护给您带来的不便，敬请谅解，感谢大家的支持和配合',
        //         type: 'warning',
        //         duration: 0,
        //         onClose:function () {
        //             localStorage.setItem("_alert_msg_","1")
        //         }
        //     });
		// }

	}
}
</script>

<style>
#buttonContainer {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
}
#backToTopBtn {
    cursor: pointer;
    border: none;
    background-color: transparent;
    padding: 10px;
}
#toggleBtn {
    position: absolute;
    top: -10px;
    right: 0;
    cursor: pointer;
    padding: 0px;
    border-radius: 50%;
}
.msg{
	font-size: 13px;
	color: white;
	display: inline-block;
	vertical-align: middle;
	cursor: pointer;
	margin-left: 0.2rem;
	word-wrap: break-word;
}
</style>
